export const TOGGLE_NOTIFICATION_DRAWER = 'TOGGLE_NOTIFICATION_DRAWER';
export const RECIEVE_NOTIFICATION = 'RECIEVE_NOTIFICATION';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_NOTIFICATION_READ = 'SET_NOTIFICATION_READ';
export const SET_NOTIFICATIONS_COUNT = 'SET_NOTIFICATIONS_COUNT';
export const DECREMENT_NOTIFICATIONS_COUNT = 'DECREMENT_NOTIFICATIONS_COUNT';
export const CLEAR_NOTIFICATIONS_COUNT = 'CLEAR_NOTIFICATIONS_COUNT';
